import apiClient from './api';

export interface Company {
  id: number;
  name: string;
  deactivatedDate?: string | null;
}

export interface CreateCompanyRequest {
  name: string;
}

export const companyService = {
  // Get all companies
  getAll: async (includeArchived?: boolean): Promise<Company[]> => {
    try {
      const response = await apiClient.get('/companies', { params: { includeArchived } });
      const data = response.data;

      // Ensure we always return an array
      if (!Array.isArray(data)) {
        console.warn('API returned non-array data for companies:', data);
        return [];
      }

      return data;
    } catch (error) {
      console.error('Error in companyService.getAll:', error);
      return []; // Return empty array on error
    }
  },

  // Get company by ID
  getById: async (id: number): Promise<Company> => {
    const response = await apiClient.get(`/companies/${id}`);
    return response.data;
  },

  // Create new company
  create: async (request: CreateCompanyRequest): Promise<Company> => {
    const response = await apiClient.post('/companies', request);
    return response.data;
  },

  // Update company
  update: async (id: number, company: Partial<Company>): Promise<Company> => {
    const response = await apiClient.put(`/companies/${id}`, company);
    return response.data;
  },

  // Delete company
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/companies/${id}`);
  },

  // Restore an archived company
  restore: async (id: number): Promise<void> => {
    await apiClient.post(`/companies/${id}/restore`);
  },
};
